<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Payment Method'"
          :fields="fields"
          :items="data"
          :editButton="false"
          :enableAddButton="true"
          :removeButton="true"
          :redirectDetail="false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="payment methods">Payment Methods</label>
              <model-select
                class="form-control"
                id="paymentmethod"
                :options="paymentMethodList"
                v-model="$v.agentPaymentMethodForm.payment_method.$model"
                :isError="$v.agentPaymentMethodForm.payment_method.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.agentPaymentMethodForm.payment_method.$invalid"
                class="invalid-feedback-custom"
              >Payment Method should be filled.</div>
            </div>
          </CCol>
        </CRow>
        <CRow>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.agentPaymentMethodForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "AgentPaymentMehod",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "AgentPaymentMethod",
      items: [],
      addButton: false,
      isEdit: false,
      agentPaymentMethodForm: tableInterfaces.agent_payment_method,
      isLoading: false,
      activeTab: 0,
    //   checkedFlag: "Agent",
      fields: [
        { key: "payment_name", label: "Payment Method", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agent: {
      type: [Array, Object],
      default: () => [],
    },
    paymentMethodList: {
      type: [Array, Object],
      default: () => [],
    },
    agentStatus: {
        type: String,
        default: '',
    },
    agentPaymentMethod: {
      type: [Array, Object],
      default: () => [],
    },
  },
  validations: {
    agentPaymentMethodForm: {
      payment_method: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function() {
      return (this.items.length > 0) ? this.items: this.agentPaymentMethod;
    }
  },
  methods: {
    init: function () {
    },
    refreshPaymentMethod: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_payment_method/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
           
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.title = "Edit Payment method"
      this.isEdit = true;
      this.resetForm();
      this.agentPaymentMethodForm = item;
      this.addButton = true;
    },
    removeData: function(item) {
       if (confirm("Do you want to remove this data ?")) {
      this.isLoading = true;
          this.axios
            .delete("console/agent/agent_payment_method/"+item.id)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshPaymentMethod(this.agent.id);
            });
       }
      // bikin api untuk remove 
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent_payment_method) {
        tableInterfaces.agent_payment_method[i] = null;
      }
      this.agentPaymentMethodForm = tableInterfaces.agent_payment_method;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.agentPaymentMethodForm.agent_code = this.agent.agent_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/agent/agent_payment_method/update", this.agentPaymentMethodForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshPaymentMethod(this.agent.id);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/agent/agent_payment_method/add", this.agentPaymentMethodForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshPaymentMethod(this.agent.id);
            });
        }
      }
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
